import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { AuthorizationToggleModule } from 'ish-core/authorization-toggle.module';
import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { PipesModule } from 'ish-core/pipes.module';
import { RoleToggleModule } from 'ish-core/role-toggle.module';

import { PresidioImpersonationBannerComponent } from '../../../extensions/presidio-demo/components/presidio-impersonation-banner.component';
import { PresidioImpersonationPickerComponent } from '../../../extensions/presidio-demo/components/presidio-impersonation-picker.component';
import { SalesRepExportsModule } from '../../../extensions/sales-rep/exports/sales-rep-exports.module';
import { SalesRepAccountBannerComponent } from '../../../extensions/sales-rep/shared/sales-rep-account-banner/sales-rep-account-banner.component';

import { CustomAccountMenuComponent } from './custom-account-menu.component';
import { CustomAllDrawerComponent } from './custom-all-drawer.component';
import { CustomContactMenuComponent } from './custom-contact-menu.component';
import { CustomNotificationsMenuComponent } from './custom-notifications-menu.component';
import { CustomShellFabsComponent } from './custom-shell-fabs.component';

const components = [
  CustomAllDrawerComponent,
  CustomAccountMenuComponent,
  CustomContactMenuComponent,
  CustomNotificationsMenuComponent,
  CustomShellFabsComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FeatureToggleModule,
    AuthorizationToggleModule,
    RoleToggleModule,
    PipesModule,
    RouterModule,
    TranslatePipe,
    SalesRepExportsModule,
    PresidioImpersonationPickerComponent,
    PresidioImpersonationBannerComponent,
    SalesRepAccountBannerComponent,
  ],
  declarations: [...components],
  exports: [
    ...components,
    PresidioImpersonationPickerComponent,
    PresidioImpersonationBannerComponent,
    SalesRepAccountBannerComponent,
  ],
})
export class ShellChromeModule {}
